import { Card, Box, Stack, Divider, Typography, Button } from "@mui/material";
import { Link } from "react-router";

type CollapsibleBoxProps = {
  title: string;
  subtitle: string;
  copy1: string;
  copy2: string | null;
  linkText: string;
  linkPath: string;
  onClick?: () => void;
};

export const CollapsibleBox = ({
  title,
  subtitle,
  copy1,
  copy2,
  linkText,
  linkPath,
  onClick,
}: CollapsibleBoxProps) => {
  return (
    <Box mb={2}>
      <Card variant="outlined" sx={{ maxWidth: 600 }}>
        <Box sx={{ p: 4 }}>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography gutterBottom variant="h6" component="div">
              {subtitle}
            </Typography>
          </Stack>
          <Divider />

          <Typography variant="body1" mt={2}>
            {copy1}
          </Typography>

          {copy2 && <Typography variant="body1">{copy2} </Typography>}
          <Box mt={2}>
            <Button
              component={Link}
              to={linkPath}
              variant="contained"
              color="primary"
              onClick={onClick}
            >
              {linkText}
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
